export type NavLinkItem = {
  id: string;
  label: string;
  url: string;
  isRouterLink: boolean;
};

export const BROWSE_RETREATS_URL = '/retreats';
export const BROWSE_CHALLENGES_URL = '/challenges';

export const NAV_LINKS: NavLinkItem[] = [
  { id: 'science', label: 'Science', url: '/science', isRouterLink: false },
  {
    id: 'therapists',
    label: 'Therapists',
    url: '/therapists',
    isRouterLink: false
  },
  { id: 'newsroom', label: 'Newsroom', url: '/news', isRouterLink: false },
  { id: 'about', label: 'About', url: '/about', isRouterLink: false }
];

export const MOBILE_TABS: NavLinkItem[] = [
  { id: 'home', label: 'Home', url: '/', isRouterLink: false },
  {
    id: 'therapists',
    label: 'Therapists',
    url: '/therapists',
    isRouterLink: false
  },
  { id: 'science', label: 'Science', url: '/science', isRouterLink: false },
  { id: 'about', label: 'About', url: '/about', isRouterLink: false },
  { id: 'newsroom', label: 'Newsroom', url: '/news', isRouterLink: false },
  { id: 'events', label: 'Events', url: '/live', isRouterLink: false }
];

export const BROWSE_ALPHABET: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export const FLUX_BAR_HEIGHT = { base: '56px', xl: '72px' };

// Spacer matches the flux bar plus (on mobile) the tab row. base (56px + 39px)
// is calculated, not measured: unverified until checked in a browser.
export const FLUX_SPACER_HEIGHT = { base: '95px', lg: '56px', xl: '72px' };
